import React, { useEffect, useRef } from 'react'
import { BusyButton } from '@ztechapps/webui.button'
import { Form } from 'react-bootstrap'
import { Alert, ShowIf } from '@ztechapps/webui.util'
import { useRecaptcha } from '@ztechapps/common.hook'

export type BasicLoginFormProps = {
  joinPagePath?: string
  handleSubmit?: ({ username, password }) => Promise<void>
  errorMessage?: string
  forgotPasswordComponent?: React.ReactNode
  isLoading?: boolean
  handleForgotPasswordLink?: any
  formAction: string
  recaptchaSiteKey: string
  submitText?: string
}

export const BasicLoginForm = ({
  formAction,
  errorMessage,
  forgotPasswordComponent,
  isLoading,
  handleForgotPasswordLink,
  recaptchaSiteKey,
  submitText = 'Login',
}: BasicLoginFormProps) => {
  const [localErrorMessage, setErrorMessage] = React.useState(null)
  const [localLoading, setIsLoading] = React.useState(false)
  const [username, setUsername] = React.useState('')
  const [password, setPassword] = React.useState('')

  useEffect(() => setErrorMessage(errorMessage), [errorMessage])
  useEffect(() => setIsLoading(isLoading), [isLoading])
  const recaptchaRef = useRef(null)

  const { getTokenOrThrow } = useRecaptcha({ recaptchaSiteKey })

  const onSubmit = async (args) => {
    try {
      setIsLoading(true)
      args.preventDefault()

      recaptchaRef.current.value = await getTokenOrThrow()

      //resubmit the form
      return args.target.submit()
    } catch (e) {
      setErrorMessage(e?.message ?? e)
      setIsLoading(false)
    }
  }

  return (
    <Form action={formAction} method="post" onSubmit={onSubmit}>
      <Form.Control type="hidden" name="recaptchaToken" id="recaptchaToken" ref={recaptchaRef} />
      <Form.Group>
        <Form.Label> Email:</Form.Label>
        <Form.Control
          type="email"
          id="loginUsername"
          required
          value={username}
          name="username"
          onChange={(e) => setUsername(e?.target?.value)}
          autoComplete="off"
        />
      </Form.Group>

      <Form.Group className="mt-2">
        <Form.Label> Password:</Form.Label>
        <Form.Control
          type="password"
          id="loginPassword"
          name="password"
          required
          value={password}
          onChange={(e) => setPassword(e?.target?.value)}
          autoComplete="off"
        />
      </Form.Group>

      <ShowIf condition={localErrorMessage}>
        <div className="mt-3">
          <Alert text={localErrorMessage} />
        </div>
      </ShowIf>

      {forgotPasswordComponent || (
        <div className="mb-1 float-end" onClick={handleForgotPasswordLink}>
          <a href="/" onClick={(e) => e.preventDefault()}>
            <small>Forgot your password?</small>
          </a>
        </div>
      )}

      <div className=" d-grid ">
        <BusyButton type="submit" bsStyle="primary" isBusy={localLoading}>
          {submitText}
        </BusyButton>
      </div>
    </Form>
  )
}
